import styles from './DescriptionMinigridView.module.scss';
import InstallationCodeLink from '../../../InstallationCode/InstallationCodeLink';
export interface DescriptionMinigridViewProps {
    text?: string;
    title?: string;
    createdAt?: string;
    updatedAt?: string;
    installationCode?: string | null;
}
export default function DescriptionMinigridView({text, title = 'Description', createdAt, updatedAt, installationCode}: DescriptionMinigridViewProps)  {
  return (
    <div className={styles['container']}>
    <h2 className={styles['container__title']}>Code installation</h2>
    <p className={styles['container__text-content']} data-testid="installation-code">
      <InstallationCodeLink code={installationCode} />
    </p>
    <h2 className={styles['container__title']}>{title}</h2>
    <p className={styles['container__text-content']}>{text}</p>
    {createdAt && (
        <p className={styles["container__date"]}>
          Crée le {createdAt}{" "}
          {createdAt !== updatedAt && <>et mise à jour le {updatedAt}</>}
        </p>
      )}
    </div>
  )
}
